import { createFeatureSelector } from '@ngrx/store';
import { DocumentUploadState } from './document-upload.state';

export const selectDocumentUploadState = createFeatureSelector<DocumentUploadState>('documentUploadStore');